// TIP-611 — label, required marker, control. Every field in the order form is
// this shape, so the marker and the label type are declared once.
import React from "react";
import "./counterpartyBriefs.css";

export const CbLabel = ({ htmlFor, label, required }) => (
  <label className="cb-field-label" htmlFor={htmlFor}>
    {label}
    {required && (
      <span className="cb-field-required" aria-hidden="true">
        {" *"}
      </span>
    )}
  </label>
);

// TIP-611 — `error` is the message the BACKEND sent about this field. It marks
// the control and prints underneath, so a rejection listed in the banner at the
// top can also be found at the field itself.
// `warning` is advice, not a rejection: it prints under the control the same
// way an error does but leaves the field valid — no `aria-invalid`, no red
// outline, and nothing about it stops the submit. An error wins when a field
// somehow has both, because that is the one the customer must act on.
const CbField = ({ id, label, required, wide, hidden, error, warning, children }) => {
  if (hidden) return null;
  const showWarning = !error && warning;
  return (
    <div className={`cb-field${wide ? " cb-field--wide" : ""}${error ? " cb-field--error" : ""}`}>
      <CbLabel htmlFor={id} label={label} required={required} />
      {children}
      {error && (
        <p id={id ? `${id}-error` : undefined} className="cb-field-error">
          {error}
        </p>
      )}
      {showWarning && (
        <p id={id ? `${id}-warning` : undefined} className="cb-field-warning" role="status">
          {warning}
        </p>
      )}
    </div>
  );
};

// The plain text input, which is most of the 24.
export const CbTextField = ({ id, label, required, wide, hidden, error, warning, ...rest }) => (
  <CbField
    id={id} label={label} required={required} wide={wide} hidden={hidden}
    error={error} warning={warning}
  >
    <input
      id={id}
      type="text"
      className={`cb-input${error ? " cb-input--error" : ""}`}
      required={required}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={
        (error && id && `${id}-error`) || (warning && id && `${id}-warning`) || undefined
      }
      {...rest}
    />
  </CbField>
);

export default CbField;
